export const getOrdersApi = async (token, user_id, filter = null) => {
  let URL = `${process.env.REACT_APP_API_BASE_URL}/users/${user_id}/orders`;
  if (filter) {
    URL += `?${filter}=true`;
  }

  const requestOptions = {
    method: 'GET',
    headers: {
      Authorization: 'Token token=' + token,
    }
  };

  const response = await fetch(URL, requestOptions);

  if (response.status === 422) {
    throw new Error('Unprocessable Entity');
  }
  if (response.status === 500) {
    throw new Error('Internal Server Error');
  }

  const jsonResponse = await response.json();

  return jsonResponse;
};

export const getOrderApi = async (token, user_id, order_id) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}/users/${user_id}/orders/${order_id}`;
  const requestOptions = {
    method: 'GET',
    headers: {
      Authorization: 'Token token=' + token,
    }
  };

  const response = await fetch(URL, requestOptions);

  if (response.status === 422) {
    throw new Error('Unprocessable Entity');
  }
  if (response.status === 500) {
    throw new Error('Internal Server Error');
  }

  const jsonResponse = await response.json();

  return jsonResponse;
};

export const createOrderApi = async (token, user_id, params) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}/users/${user_id}/orders`;
  const requestOptions = {
    method: 'POST',
    headers: {
      Authorization: 'Token token=' + token,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(params)
  };

  const response = await fetch(URL, requestOptions);

  if (response.status === 422) {
    throw new Error('Unprocessable Entity');
  }
  if (response.status === 500) {
    throw new Error('Internal Server Error');
  }

  const jsonResponse = await response.json();

  return jsonResponse;
};

export const updateOrderApi = async (token, user_id, params) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}/users/${user_id}/orders`;
  const requestOptions = {
    method: 'PUT',
    headers: {
      Authorization: 'Token token=' + token,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(params)
  };

  const response = await fetch(URL, requestOptions);

  if (response.status === 422) {
    throw new Error('Unprocessable Entity');
  }
  if (response.status === 500) {
    throw new Error('Internal Server Error');
  }

  const jsonResponse = await response.json();

  return jsonResponse;
};

export const destroyOrderApi = async (token, user_id, order_id) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}/users/${user_id}/orders/${order_id}`;
  const requestOptions = {
    method: 'DELETE',
    headers: {
      Authorization: 'Token token=' + token,
    }
  };

  const response = await fetch(URL, requestOptions);

  if (response.status === 422) {
    throw new Error('Unprocessable Entity');
  }
  if (response.status === 500) {
    throw new Error('Internal Server Error');
  }

  const jsonResponse = await response.json();

  return jsonResponse;
};

export const exportOrderApi = async (token, user_id) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}/users/${user_id}/orders/export`;
  const requestOptions = {
    method: 'GET',
    responseType: 'blob',
    headers: {
      Authorization: 'Token token=' + token,
      'Content-Type': 'application/octet-stream',
      'Content-Disposition': 'attachment;'
    }
  };

  const response = await fetch(URL, requestOptions);

  if (response.status === 422) {
    throw new Error('Unprocessable Entity');
  }
  if (response.status === 500) {
    throw new Error('Internal Server Error');
  }

  return response;
};

export const importOrderApi = async (token, user_id, file) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}/users/${user_id}/orders/import`;

  var data = new FormData();
  data.append("file", file);

  const requestOptions = {
    method: 'POST',
    headers: {
      Authorization: 'Token token=' + token,
    },
    body: data
  };

  const response = await fetch(URL, requestOptions);

  if (response.status === 422) {
    throw new Error('Unprocessable Entity');
  }
  if (response.status === 500) {
    throw new Error('Internal Server Error');
  }

  return response;
};
